<h5 class="header">Pro Ids</h5>
<div class="row no-gutters">
  <div class="pro-accounts">
    <ng-container *ngIf="!proAccountsIsLoading; else proAccountsLoading">
      <ng-container
        *ngIf="proAccounts && proAccounts.length; else noProAccounts"
      >
        <div *ngFor="let proAccount of proAccounts">
          <div class="pro-account">
            {{ proAccount?.name }} (#{{ proAccount?.id }})
            <i
              *ngIf="edit"
              [ngbTooltip]="
                isMappedToMigration(proAccount.id)
                  ? 'Cannot be removed due to active migration'
                  : 'Unlink Pro account'
              "
              (click)="
                deleteLink({
                  proAccountId: proAccount.id,
                  proAccountName: proAccount.name
                })
              "
              class="fas fa-unlink"
              [class.disabled]="isMappedToMigration(proAccount.id)"
            ></i>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div class="pro-account-add-action">
      <app-pro-account-ids-form
        *ngIf="addNew"
        (saveNewProLink)="onSaveNewProLink($event)"
      ></app-pro-account-ids-form>
      <button
        *ngIf="edit"
        class="btn btn-link pro-account-btn"
        (click)="toggleAddNew()"
      >
        <em class="fas fa-link"></em> {{ addNew ? 'Cancel' : 'Add' }}
      </button>
    </div>
  </div>
  <ng-template #proAccountsLoading>
    <app-loading-spinner></app-loading-spinner>
  </ng-template>
  <ng-template #noProAccounts>
    <div *ngIf="!edit" class="alert alert-info">
      No Pro accounts are currently linked.
    </div>
  </ng-template>
</div>
<div class="row">
  <span class="col-auto ml-auto" [ngbTooltip]="editAccountMessage">
    <button
      class="btn btn-link"
      (click)="onEdit()"
      [disabled]="!canPlaceOrders || accountState === AccountState.Failed"
    >
      <em class="fas fa-pencil-alt"></em> {{ edit ? 'Cancel' : 'Edit' }}
    </button>
  </span>
</div>
